import React from 'react'

import './FocusReactions.scss'

const FocusReactions = () => {
  return (
    <div className="focus-widget focus-reactions">
      <span>1&thinsp;👍</span>
      <span>2&thinsp;😃</span>
      <span>1&thinsp;❤️</span>
      <span>1&thinsp;👏</span>
      <span>1&thinsp;💡</span>
    </div>
  )
}
export { FocusReactions }
